import service from '@/middleware'

const thingApi = {
    /**
     * Para obtener los datos de las cosas para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} enterprises
     * @param {*} types
     */
    async findAll(pageSize, pageNumber, enterprises, types) {
        const url = pageSize != null && pageNumber != null
            ? `/api/thing/abm-all?pageSize=${pageSize}&pageNumber=${pageNumber}`
            : `/api/thing/abm-all`
        const user = await service.http.post(url, { enterprises, types })
        return user
    },

    async findAllForGoalsABM(pageSize, pageNumber, enterprises, types) {
        const url = pageSize != null && pageNumber != null
            ? `/api/thing/goals-abm?pageSize=${pageSize}&pageNumber=${pageNumber}`
            : `/api/thing/goals-abm`
        const user = await service.http.post(url, { enterprises, types })
        return user
    },
    /**
     * Para obtener el total de cosas de la collection para el paginador de la tabla del ABM
     * @param {*} enterprises
     * @param {*} types
     */
    async getTotalCount (enterprises, types) {
        const result = await service.http.post(`/api/thing/abm-total`, { enterprises, types })
        return result
    },
    /**
     * Para obtener el arreglo de tipos de cosas para los selectores del ABM
     */
    async getTypesForSelector () {
        const result = await service.http.get(`/api/thing/types-for-selector`)
        return result
    },
    /**
     * Para crear una nueva cosa
     * @param {*} thing
     */
    async create (thing) {
        const result = await service.http.post(`/api/thing/create`, thing)
        return result
    },
    /**
     * Para actualizar una cosa
     * @param {*} thing
     */
    async update (thing) {
        const result = await service.http.put(`/api/thing/update`, thing)
        return result
    },
    /**
     * Para eliminar una cosa
     * @param {*} id
     */
    async delete (id) {
        const result = await service.http.delete(`/api/thing/${id}`)
        return result
    },
    /**
     * Para elminación múltiple
     * @param {*} ids
     */
    async multipleDelete (ids) {
        const result = await service.http.put(`/api/thing/multiple-delete`, ids)
        return result
    },
    /**
     * Arreglo de cosas que pertenezcan a las empresas enviadas como param
     * @param {*} enterpriseIds
     */
    async getThingsWithoutGroupByEnterpriseId(enterpriseIds) {
        const result = await service.http.post(`/api/thing/without-group-by-enterprises`, enterpriseIds)
        return result
    },
    /**
     * Arreglo de cosas sin flotas que pertenezcan a las empresas enviadas como param
     * @param {*} enterpriseIds
     */
    async getThingsWithoutFleetByEnterpriseId(enterpriseIds) {
        const result = await service.http.post(`/api/thing/without-fleet-by-enterprises`, enterpriseIds)
        return result
    },
    /**
     * Arreglo de cosas sin frentes de trabajo que pertenezcan a las empresas enviadas como param
     * @param {*} enterpriseIds
     */
    async getThingsWithoutWorkFrontByEnterpriseId(enterpriseIds) {
        const result = await service.http.post(`/api/thing/without-work-front-by-enterprises`, enterpriseIds)
        return result
    },
    /**
     * Devuelve los datos de una cosa para el dialog de actualización
     * @param {*} id
     */
    async getThing(id) {
        const result = await service.http.get(`/api/thing/one/${id}`)
        return result
    },

    /**
     * Claves de actividades, tipos y sectores para completar los datos para carga masiva
     */
    async getMassiveUploadInformationData() {
        const result = await service.http.get(`/api/thing/massive-upload-information-data`)
        return result
    },

    /**
     * Para obtener las cosas (equipos) para los selectores
     * (Reporte de comandos enviados)
     */
    async getAllForSelector () {
        const result = await service.http.get(`/api/thing/all-for-selector`)
        return result
    },

    /**
     * Selector de vehículos de scoring
     * @param {*} enterpriseIds
     */
    async getVehicleSelector (enterpriseIds) {
        return await service.http.post(`/api/thing/scoring-vehicles-selector`, enterpriseIds);
    },

    /**
     * Devuelve una estructura anidad de cosas para asignar a los usuarios
     * empresas -> grupos -> equipos
     * @param {*} enterpriseIds
     * @param {*} selectedIds
     */
    async getThingsNestedInEnterprises (enterpriseIds, selectedIds, userId) {
        const url = userId ? `/api/thing/things-user-abm?userId=${userId}` : '/api/thing/things-user-abm'
        return await service.http.post(url, { enterpriseIds, selectedIds })
    },

    async getRuses () {
        return await service.http.get(`/api/thing/ruses/all`)
    },

    async getRusKeys () {
        return await service.http.get(`/api/thing/ruses/keys`)
    },

    async getEnterpriseRusConfiguration(enterpriseId, typeId) {
        return await service.http.get(`/api/thing/ruses/configuration`, { params: { enterpriseId, typeId } })
    },

    async getEnterpriseEventConfiguration(enterpriseId, typeId) {
        return await service.http.get(`/api/thing/event/configuration`, { params: { enterpriseId, typeId } })
    },

    async getAllNestedByEnterprise(enterpriseIds) {
        return await service.http.post(`/api/thing/nested-enterprise`, enterpriseIds)
    },

    async getAllNestedByActivity(enterpriseIds) {
        return await service.http.post(`/api/thing/nested-activity`, enterpriseIds)
    },

    async getAllNested(enterpriseIds) {
        return await service.http.post(`/api/thing/nested`, enterpriseIds)
    },

    async getWorkFrontsByEnterpriseId(enterpriseId) {
        return await service.http.get(`/api/thing/workFronts/${enterpriseId}`)
    },

    async isGpsAlreadyAssigned(gpsId, thingId) {
        return await service.http.get(`/api/thing/validate-assigned-gpsId/${gpsId}/${thingId}`)
    },

    async hasTracksComputed(thingId) {
        return await service.http.get(`/api/thing/has-tracks-computed/thing/${thingId}`)
    },

    async getNested(thingType = null) {
        const path =
            thingType != null
                ? `/api/thing/all-nested?thingType=${thingType}`
                : "/api/thing/all-nested";
        const response = await service.http.get(path);
        return response;
    },
    async getDefaultValuesLevelControl() {
        return await service.http.get('/api/thing/default-values-level-control');
    }
}

export default thingApi
